import type {SbRichTextDoc as ISbRichtext} from "@storyblok/js";

export default function isFilledRichText(value: ISbRichtext) {
	const first = value?.content?.[0];
	if (!first) {
		return false;
	}

	/**
    Filled if the first element isn't a paragraph or it's a paragraph that has content.
    If users manually empty a rich text field it will contain an empty paragraph, that should be considered empty.
    */
	return first.type !== "paragraph" || !!first.content;
}
